import type {
    ICustomerFulfillmentChangedEvent,
} from "@/data/model/Events";
import { DateTime } from "@/data/util/DateTime";

export class SocketEventParser {
    public static parseCustomerFulfillmentChangedEvent(literal: any): ICustomerFulfillmentChangedEvent {
        return {
            identityId: literal.identityId,
            fulfillmentGroupId: literal.fulfillmentGroupId == null ? undefined : literal.fulfillmentGroupId,
            locationId: literal.locationId,
            orderId: literal.orderId,
            scheduledFulfillmentDateTime:
                literal.scheduledFulfillmentDateTime == null
                    ? undefined
                    : DateTime.parseIsoDate(literal.scheduledFulfillmentDateTime),
        };
    }
}
